import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ScrapeJobsHeader } from "./ScrapeJobsHeader";
import { ScrapeJobsTable } from "./ScrapeJobsTable";
import { EditScrapeJobModal } from "./EditScrapeJobModal";
import {
  fetchScrapeJobs,
  deleteScrapeJob,
  updateScrapeJob
} from "../../../features/scrapeJob/scrapeJobSlice";

export const ScrapeJobsPage = () => {
  const dispatch = useDispatch();
  const {
    scrapeJobs,
    pagination,
    loading,
    error,
    deleteLoading,
    updateLoading
  } = useSelector((state) => state.scrapeJob);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [selectedJob, setSelectedJob] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchScrapeJobs({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleLoadMore = () => {
    const nextPage = pagination.currentPage + 1;
    dispatch(fetchScrapeJobs({ page: nextPage, limit: 10 }));
  };

  const handleDeleteJob = async (jobId) => {
    if (window.confirm('Are you sure you want to delete this scrape job?')) {
      try {
        await dispatch(deleteScrapeJob(jobId)).unwrap();
      } catch (err) {
        console.error('Failed to delete scrape job:', err);
      }
    }
  };

  const handleEditJob = (job) => {
    setSelectedJob(job);
    setIsEditModalOpen(true);
  };

  const handleUpdateJob = async (jobData) => {
    try {
      await dispatch(updateScrapeJob({
        id: selectedJob._id,
        jobData
      })).unwrap();
      setIsEditModalOpen(false);
      setSelectedJob(null);
    } catch (err) {
      console.error('Failed to update scrape job:', err);
    }
  };

  // Filter jobs based on search and status
  const filteredJobs = scrapeJobs.filter((job) => {
    const q = search.toLowerCase();
    const matchesSearch =
      !q ||
      job.jobName?.toLowerCase().includes(q) ||
      job.playerName?.toLowerCase().includes(q) ||
      job.sourceUrl?.toLowerCase().includes(q);
    const matchesStatus =
      statusFilter === "All" || job.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="rounded-3xl bg-jp-card border border-jp-line shadow-sm p-6 space-y-4">
      {error && (
        <div className="p-3 bg-red-900/20 border border-red-500 rounded-lg">
          <p className="text-red-600 dark:text-red-400 text-sm">{error}</p>
        </div>
      )}

      <ScrapeJobsHeader
        search={search}
        onSearchChange={setSearch}
        status={statusFilter}
        onStatusChange={setStatusFilter}
      />

      <ScrapeJobsTable
        jobs={filteredJobs}
        loading={loading}
        onDelete={handleDeleteJob}
        onEdit={handleEditJob}
        deleteLoading={deleteLoading}
        onLoadMore={handleLoadMore}
        pagination={pagination}
      />

      {isEditModalOpen && selectedJob && (
        <EditScrapeJobModal
          job={selectedJob}
          isOpen={isEditModalOpen}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedJob(null);
          }}
          onUpdate={handleUpdateJob}
          loading={updateLoading[selectedJob._id]}
        />
      )}
    </div>
  );
};
